const version = "Bellini bears 2025-12-09";

export default version;
